<div class="centered_page middleAlignBlock">
    <div class="middleAlign">
  <div class="">
  <div class="pagenotfound_block">
      <!-- <div class="hidden-xs hidden-sm myaccnt_modal_closeicon" (click)="closeModal('completeProfile')">
        <i class="icon-cancel-1"></i>
      </div> -->
      <!-- <div class="hidden-md hidden-lg mobile_modal_closeicon">
          <i class="icon-cancel-1"></i>
        </div> -->
      <div class="">
        <h3 class="text-center">{{'footersticknavComp.footersticknav20' | translate}}</h3>
        <p>{{'footersticknavComp.footersticknav21' | translate}}</p>
        <div>
          <button (click)="gotoHome()" class="button_margin site-btn site-btn__primary site-btn--lg">{{'footersticknavComp.footersticknav14' | translate}}</button>
        </div>
      </div>
      </div>
    </div>
    </div>
  </div>
